import { createFileRoute } from "@tanstack/react-router";
import SampleManageDetail from "./-sampleManageDetail";

function SampleManageDetailPage() {
  const { id } = Route.useSearch();
  return <SampleManageDetail id={id} />;
}

export const Route = createFileRoute("/_layout/opr/sampleManageDetail")({
  validateSearch: (search: Record<string, unknown>) => ({
    id: String(search.id ?? ""),
  }),
  preload: false,
  staticData: {
    menuLabel: "寄样详情",
    menuHighlightPath: "/opr/sampleManage",
  },
  component: SampleManageDetailPage,
});
